/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceSprache as AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-sprache';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IUserSettingsDisplayModel {
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
}
export class UserSettingsDisplayModel extends BaseModel implements IUserSettingsDisplayModel {
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
}
class BaseUserSettingsDisplayModelFormGroup extends FormGroup {
  private static _instance: UserSettingsDisplayModelFormGroup;
  
  public static get Instance(): UserSettingsDisplayModelFormGroup {
    this._instance = new UserSettingsDisplayModelFormGroup({
      sprache: new FormControl(null),
    });

    return this._instance;
  }
}


export class UserSettingsDisplayModelFormGroup extends BaseUserSettingsDisplayModelFormGroup {
  public get Sprache(): FormControl {
    return this.controls["sprache"] as FormControl;
  }
  

}

export module UserSettingsDisplayModelForm
  {
    export class FormFields
    {
      static _sprache: string = "sprache";
    }
  }

